import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Typography, Container, CircularProgress, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { myDesignService } from "../../services";
import DndKit from "../dragNDrop/DndKit";
import HorizontalDraggable from "../dragNDrop/draggableElements/HorizontalDraggable";

const PREFIX = "CampaignPlaylistManager";

const classes = {
  playlistsContainer: `${PREFIX}-playlistsContainer`,
  playlistManagementTitle: `${PREFIX}-playlistManagementTitle`,
  playlistContainer: `${PREFIX}-playlistContainer`,
  loaderContainer: `${PREFIX}-loaderContainer`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.playlistsContainer}`]: {
    marginTop: "1rem",
  },

  [`& .${classes.playlistManagementTitle}`]: {
    [theme.breakpoints.up("sm")]: {
      justifyContent: "center",
    },
  },

  [`& .${classes.playlistContainer}`]: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: "70vh",
    marginTop: "1rem",
    maxWidth: "350px",
    margin: "0 auto",
    [theme.breakpoints.up("sm")]: {
      minWidth: "350px",
    },
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`&.${classes.loaderContainer}`]: {
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
    width: "20%",
    marginTop: "2rem",
  },
}));

export default function CampaignPlaylistManager(props) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [items, setItems] = useState(null);
  const toastError = () =>
    enqueueSnackbar(t("toasts.errorDeleteCampaignElement"), {
      variant: "error",
    });
  const toastErrorUpdate = () =>
    enqueueSnackbar(t("toasts.errorUpdateCampaignElement"), {
      variant: "error",
    });

  useEffect(() => {
    if (props.playlist) {
      setItems(props.playlist);
    }
  }, [props.playlist]);

  const deleteElement = (item) => {
    myDesignService
      .deleteElementToCampaignPlaylist(
        props.selectedCampaign.campaignId,
        props.selectedCampaign.campaign.id,
        item.id,
        toastError
      )
      .then(() => {
        let tmp = [...props.content];
        tmp.push(item.user);
        props.setContent(tmp);
        const tmp2 = [...props.playlist];
        const indexToRemove = tmp2.findIndex((el) => el.id === item.id);
        tmp2.splice(indexToRemove, 1);
        props.setPlaylist(tmp2);
      })
      .catch(() =>
        enqueueSnackbar(t("toasts.unknownError"), { variant: "error" })
      );
  };

  const handleSaveOrderedArray = (newArr, elemId, newIndex) => {
    setItems(newArr);
    myDesignService.updateCampaignPlaylist(
      props.selectedCampaign.campaignId,
      props.selectedCampaign.id,
      elemId,
      newIndex + 1,
      toastErrorUpdate
    );
  };

  if (!props.playlist || !items) {
    return (
      <Container>
        <Root>
          <div className={classes.loaderContainer}>
            <CircularProgress size={50} />
          </div>
        </Root>
      </Container>
    );
  } else {
    return (
      <Root>
        <div
          className={classes.playlistsContainer}
          style={{ overflow: "auto" }}
        >
          <Typography
            variant="h5"
            style={{ display: "flex" }}
            className={classes.playlistManagementTitle}
          >
            {t("myDesign.zones.playlists.playlistManagementTitle")}
          </Typography>
          <div
            className={classes.playlistContainer}
            style={{ overflow: "auto" }}
          >
            {props.playlist.length === 0 ? (
              <Typography variant="body1" className={classes.marginTop}>
                {t("myDesign.zones.playlists.emptyPlaylist")}
              </Typography>
            ) : (
              <Paper elevation={10} sx={{ marginBottom: "2rem" }}>
                <DndKit
                  mode={"vertical"}
                  getObjectMovedInfos
                  customWidth
                  data={items}
                  reorderedArray={(newArray, elemId, newIndex) =>
                    handleSaveOrderedArray(newArray, elemId, newIndex)
                  }
                  renderItem={(elem, index) => (
                    <HorizontalDraggable
                      title={elem.user.lastname + " " + elem.user.firstname}
                      onRemove={() => deleteElement(elem)}
                    />
                  )}
                />
              </Paper>
            )}
          </div>
        </div>
      </Root>
    );
  }
}
